import { Alert, Anchor, Box, Title, useComputedColorScheme } from '@mantine/core'
import { useTranslation } from 'react-i18next'

import { EventLocation } from './eventLocation'

type Props = {
  location?: EventLocation
  height?: number | string
}

const DARK_IFRAME_FILTER = 'invert(90%) hue-rotate(180deg) brightness(0.95) contrast(0.9)'

const MapyCzPanel = ({ location, height = 360 }: Props) => {
  const { t } = useTranslation('unexpectedEvents')
  const isDark = useComputedColorScheme('light') === 'dark'

  if (!location) {
    return (
      <>
        <Title order={5} mb="xs">
          {t('panels.mapyCz')}
        </Title>
        <Alert color="gray" variant="light">
          {t('header.noGps')}
        </Alert>
      </>
    )
  }

  const lat = location.latitude.toFixed(6)
  const lon = location.longitude.toFixed(6)

  return (
    <>
      <Title order={5} mb="xs">
        <Anchor
          href={`https://en.mapy.cz/dopravni?x=${lon}&y=${lat}&z=17`}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {t('panels.mapyCz')}
        </Anchor>
      </Title>
      <Box style={{ height, width: '100%' }}>
        <iframe
          title="mapy.cz"
          src={`https://frame.mapy.cz/dopravni?x=${lon}&y=${lat}&z=17`}
          style={{ border: 'none', width: '100%', height: '100%', filter: isDark ? DARK_IFRAME_FILTER : undefined }}
        />
      </Box>
    </>
  )
}

export default MapyCzPanel
